import { BaseValidationRuleResolver } from './BaseValidationRuleResolver';

export const allOrNoneValidationRuleResolver: BaseValidationRuleResolver = (value, _rule, property, path, context) => {
  const hasValue = (candidate: unknown): boolean => {
    if (candidate === null || candidate === undefined) {
      return false;
    }
    if (typeof candidate === 'string') {
      return candidate.trim().length > 0;
    }
    if (Array.isArray(candidate)) {
      return candidate.length > 0;
    }
    if (typeof candidate === 'object') {
      return Object.keys(candidate).length > 0;
    }
    return true;
  };

  if (hasValue(value)) {
    return null;
  }

  const hasValueInReferencedProperty = property.refs?.some((_, refIndex) => hasValue(context.getRefValue(property, path, refIndex)));
  return hasValueInReferencedProperty ? 'Required' : null;
};
